import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import App from "./App";
import "./styles.css";

// autoUpdate: a stale decision surface is a correctness problem, not a
// cosmetic one - it could show a candidate the council has already withdrawn.
registerSW({ immediate: true });

const el = document.getElementById("root");
if (!el) throw new Error("#root missing");

createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
